import { observer } from "mobx-react";
import React, { useEffect } from "react";

import { Cubby } from "../stores/Cubby";
import ChangeAlias from "./modals/changeAlias";
import NodeInfo from "./dataDisplay/nodeDetails";
import UserSettings from "./modals/userSettings";
import DestroyCubby from "./modals/destroyCubby";
import ShowPeers from "./dataDisplay/showPeers";
import MustEnable2Fa from "./modals/mustEnable2FA";
import ChannelInfo from "./dataDisplay/channelInfo";
import CloseChannel from "./modals/closeChannel";
import DepositBtc from "./modals/depositBtc";
import SendFundsModal from "./modals/sendFundsModal";
import OpenChannelToOtherNode from "./modals/openChannelToOtherNode";
import { MODALS } from "../helpers/constants";
import NodeIdentity from "./dataDisplay/nodeIdentity";
import SendLightning from "./modals/sendLightning";
import SendViaBoltElevenContainer from "./modals/sendViaBolt11InvoiceContainer";
import SendViaKeysendContainer from "./modals/sendViaKeysendContainer";
import ConnectToOtherNode from "./connectToOtherNode";
import CreateInvoice from "./modals/createInvoice";
import LightningOutboundEvents from "./history/lightningOutboundEvents";
import LightningInboundEvents from "./history/lightningInboundEvents";
import BitcoinWithdrawalEvents from "./history/bitcoinWithdrawalEvents";
import CubbyErrors from "./history/cubbyErrors";
import BitcoinOnchainTransactions from "./history/bitcoinOnchainTransactions";
import GetInbound from "./modals/getInbound";
import ClosedChannels from "./history/closedChannels";
import ManageUptime from "./dataDisplay/manageUptime";
import ReceiveLightning from "./modals/receiveLightning";
import ManageLightningAddress from "./modals/manageLightningAddress";
import PayToLightningAddress from "./modals/payToLightningAddress";
import ConfirmPayToLightningAddress from "./modals/confirmPayToLightningAddress";
import SignMessage from "./modals/signMessage";
import ConnectApps from "./modals/connectApps";
import SingleNostrConnection from "./modals/singleNostrConnection";
import DocsDrawer from "../docs/articleDrawer";
import LedgerItemDetail from "./dataDisplay/ledgerItemDetail";

const AllModals = observer(({ cubby }: { cubby: Cubby }) => {
  // useEffect(() => {
  //   console.log("cubby.currentModal:", cubby.currentModal);
  // }, [cubby.currentModal]);
  return (
    <>
      <MustEnable2Fa cubby={cubby} />
      <ChangeAlias cubby={cubby} />
      <NodeInfo cubby={cubby} />
      <UserSettings cubby={cubby} />
      <DestroyCubby cubby={cubby} />
      <ShowPeers cubby={cubby} />
      <ChannelInfo cubby={cubby} />

      <CloseChannel cubby={cubby} />

      <DepositBtc cubby={cubby} />
      <SendFundsModal cubby={cubby} />
      <ConnectToOtherNode cubby={cubby} />
      {cubby.currentModal === MODALS.OPEN_CHANNEL_TO_OTHER_NODE && (
        <OpenChannelToOtherNode cubby={cubby} />
      )}
      <NodeIdentity cubby={cubby} />
      <SendLightning cubby={cubby} />
      {/* <SendViaBolt11Invoice cubby={cubby} /> */}
      {/* {cubby.currentModal === MODALS.SEND_VIA_BOLT_11_INVOICE && (
        
      )} */}
      <SendViaBoltElevenContainer cubby={cubby} />
      <SendViaKeysendContainer cubby={cubby} />
      <CreateInvoice cubby={cubby} />
      <LightningOutboundEvents cubby={cubby} />
      <LightningInboundEvents cubby={cubby} />
      <BitcoinWithdrawalEvents cubby={cubby} />
      <CubbyErrors cubby={cubby} />
      <BitcoinOnchainTransactions cubby={cubby} />
      {cubby.currentModal === MODALS.GET_INBOUND && (
        <GetInbound cubby={cubby} />
      )}
      <ClosedChannels cubby={cubby} />
      <ManageUptime cubby={cubby} />
      <ReceiveLightning cubby={cubby} />
      <ManageLightningAddress cubby={cubby} />
      <PayToLightningAddress cubby={cubby} />
      {cubby.currentModal === MODALS.CONFIRM_PAY_TO_LIGHTNING_ADDRESS && (
        <ConfirmPayToLightningAddress cubby={cubby} />
      )}
      <SignMessage cubby={cubby} />
      {cubby.currentModal === MODALS.CONNECT_APPS && (
        <ConnectApps cubby={cubby} />
      )}
      {cubby.selectedNostrConnection && <SingleNostrConnection cubby={cubby} />}

      {/* drawers */}

      <DocsDrawer cubby={cubby} />
      {cubby.currentlyFocusedLedgerItemId && <LedgerItemDetail cubby={cubby} />}
    </>
  );
});

export default AllModals;
